import React, {createContext, useState, ReactNode, useEffect} from "react";
import {EOrderState, ICartContent, ICartContext, IPurchaseOrder} from "../types/orders";
import {idbGetCart, idbSetCart} from "./cartDB";
import useAuth from "../hooks/useAuth";

export const DefaultEmptyCart : IPurchaseOrder = {
	"State": EOrderState.New,
	"Priority": 0,
	"ExhibitionCode": "",
	"Notes": "",
	"BusinessInfo": undefined,
	Email: "",
	SendEmail: false,
	"Items": []
};


const CartContext = createContext<ICartContext>({} as ICartContext);

export const CartProvider = ({ children }: { children: ReactNode }) => {

    const { auth } = useAuth();

    function getDefaultCart(): ICartContent {
        return {
            purchaseOrder: Object.assign({}, DefaultEmptyCart),
            valid: true,
            businessCardBase64: undefined,

            idUser: auth?.userData?.IdUser,
        }
    }

    const [cartContent, setCartContent] = useState<ICartContent>(getDefaultCart());

    const [hydrated, setHydrated] = useState(false);

    // Load from IndexedDB only (no migration)
    useEffect(() => {
        const cartContent = getDefaultCart();
        cartContent.idUser = auth?.userData?.IdUser;
        setCartContent(cartContent);

        if(auth?.userData?.IdUser && auth?.userData?.IdUser != "") {
            (async () => {
                // "lose" the previous stored image in localStorage
                localStorage.removeItem("cartContent");

                // console.log("id pre load: " + auth?.userData?.IdUser);

                const savedCart = await idbGetCart<ICartContent>(auth!.userData!.IdUser!);
                if (savedCart && savedCart?.valid && auth?.userData?.IdUser === savedCart.idUser) {
                    //console.log("Loaded cart" +  JSON.stringify(savedCart, null, 4));

                    setCartContent(savedCart);
                }

                setHydrated(true);
            })();
        }
    }, [auth?.userData?.IdUser]);

    // Save to IndexedDB only
    useEffect(() => {
        if (!hydrated) {
            return;
        }
        if(cartContent.idUser) {
            //console.log("just saved cart " + JSON.stringify(cartContent, null, 4) );
            void idbSetCart(cartContent, cartContent.idUser);
        }
    }, [cartContent, hydrated]);

    return (
        <CartContext.Provider value={{ cartContent, setCartContent }}>
            {children}
        </ CartContext.Provider>
    );
};

export default CartContext;